import React, { useEffect, useState } from "react";
import { Wrapper } from "./MyProfile.styled";
import { Row, Col, Upload, SuccessNotification, Spin } from "components/common";
import TestIamge from "../../assets/images/img-banner.jpeg";
import UserImage from "../../assets/images/avatar-logo-2.png";
import LocationIcon from "../../assets/svg/location.svg";
import ProfileInfo from "./ProfileInfo";
import { callGetApi, callPostApi, callPutApi } from "utils/api";
import { getUser } from "utils/auth";
import { PlusCircleOutlined } from "@ant-design/icons";

const MyProfile = () => {
  const [image, setimage] = useState("");
  const [address, setAddress] = useState({});
  const [profileData, setProfileData] = useState({});
  const [accessLevel, setAccessLevel] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const user = getUser();
  const id = user?.id;

  const handelUploadPic = (file) => {
    if (file?.file?.status == "done" || file?.file?.status == "error") {
      callPostImageApi(file?.file?.originFileObj);
      getbase64(file?.file?.originFileObj);
    }
  };
  const getbase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => setimage(reader?.result);
  };
  const getApiLocation = (user) => {
    callGetApi("/location", (data) => {
      let addrs = data?.find((el) => el?._id === user?.locationId);
      setAddress(addrs)
      setIsLoading(false);
    }, (err) => {
      console.log(err);
      setIsLoading(false);
    });
  }
  const getApiRoles = () => {
    callGetApi("/roles", (data) => {
        setAccessLevel(data);
      }, (err) => {
        console.log(err);
      }
    );
  }
  const getUserDetail = () => {
    callGetApi(`/user/${id}`, (data) => {
      setProfileData(data);
      getApiLocation(data);
    }, (err) => {
      console.log(err);
    });
  };
  const getApi = () => {
    setIsLoading(true);
    getApiRoles();
    getUserDetail();
  };
  const callPostImageApi = (file) => {
    const formData_ = new FormData();
    formData_.append("file", file);
    callPutApi(`/user/profile/picture/${id}`, formData_, (data) => {
      getApi();
    }, (err) => {
      console.log(err);
    }
    );
  };
  const callPostResetPassword = () => {
    setIsLoading(true);
    callPostApi(`/auth/reset-password/${id}`, null, (data) => {
      setIsLoading(false);
      SuccessNotification("Password Reset Link sent");
    }, (err) => {
      setIsLoading(false);
      console.log(err);
    }
    );
  };

  useEffect(() => {
    getApi();
  }, []);


  return (
    <Wrapper>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <Spin />
        </div>
      ) : (
        <>
          <Row>
            <Col span={24} className="image-col">
              {" "}
              <img src={TestIamge} alt="" className="banner-image" />
            </Col>
            <Col span={24} className="main-user-col">
              <Row gutter={[20, 20]}>
                <Col xs={24} lg={24} className="main-user-image-col">
                  <Upload onChange={handelUploadPic} showUploadList={false}>
                    <div className="plus-icon-div">
                      {" "}
                      <PlusCircleOutlined className="plus-icon" />
                    </div>
                  </Upload>
                  {profileData?.profilePicture ? (
                    <img
                      src={profileData?.profilePicture}
                      alt=""
                      className="user-image"
                    />
                  ) : (
                    <img src={UserImage} alt="" className="user-image-before" />
                  )}
                </Col>
                <div className="main-section-container">
                  <Col xs={24} className="user-data-col">
                    <Row className="user-name-row">
                      <Col span={10}>
                        {" "}
                        <h4 className="user-name-text">{profileData?.username}</h4>
                      </Col>
                      <Col span={14}>
                        <div className="location-container">
                          <img
                            src={LocationIcon}
                            alt=""
                            className="vector-image"
                          />
                          <h6 className="user-address">
                            {address?.name} ,{address?.state}
                          </h6>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              </Row>
            </Col>
            <Col span={24}>
              <ProfileInfo
                profileData={profileData}
                accessLevel={accessLevel}
                address={address}
                hanldeReset={callPostResetPassword}
                isLoading={isLoading}
              />
            </Col>
          </Row>
        </>
      )}
    </Wrapper>
  );
};

export default MyProfile;
